<template>
  <v-layout
    class="wallet-card"
  >
    <v-flex
      v-if="$apollo.loading"
      text-center
    >
      <v-progress-circular
        :size="40"
        color="primary"
        class="mb-2"
        indeterminate
      /><br>
      <b>{{ $t('packs.almostDone') }}</b>
    </v-flex>
    <v-flex
      v-show="!$apollo.loading && step == 1"
    >
      <v-text-field
        v-model.trim="stakingWallet"
        name="staking-wallet"
        :placeholder="$t('wallets.stakingWalletPlaceholder')"
        :label="$t('wallets.stakingWallet')"
        :error-messages="walletError"
        @input="$v.stakingWallet.$touch()"
        @blur="$v.stakingWallet.$touch()"
      >
        <template v-slot:append>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">
                mdi-information-outline
              </v-icon>
            </template>
            {{ $t("wallets.stakingWalletHint") }}
          </v-tooltip>
        </template>
      </v-text-field>
      <center>
        <p class="mt-5 mb-5">
          {{ $t("wallets.dontHaveWallet") }}
          <a
            :href="$i18n.locale =='ru' ? `https://aivia.io/blog/ru/kak-vierifitsirovat-svoi-koshieliek-dlia-tokienov-aiv-na-erc20/` : `https://aivia.io/blog/en/how-to-verify-erc-20-wallet-to-receive-aiv-token/`"
            target="_blank"
          >{{ $t('wallets.instruction') }}
          </a>
        </p>

        <v-divider />
        <v-btn
          class="primary mt-4"
          :disabled="loading"
          :loading="loading"
          @click="verifyWallet()"
        >
          {{ $t("wallets.startVerificationButton") }}
        </v-btn>
      </center>
    </v-flex>
          
    <v-flex
      v-if="step == 2"
      pb-5
    >
      <center>
        <countdown
          :time="countDownTime"
          :transform="transform"
          @end="handleCountDownEnd"
        >
          <template slot-scope="props">
            {{ $t("wallets.timeRemaining") }}
            <br>
            <b>
              {{ props.hours }}:{{ props.minutes }}:{{ props.seconds }}
            </b>
          </template>
        </countdown>
        <br>
        <v-btn
          v-if="startOverButton"
          style="margin-top:10px;"
          small
          text
          outlined
          @click="startOver()"
        >
          {{ $t("wallets.startOverButton") }}
        </v-btn>
        <div v-if="!startOverButton && !waitingMetamaskResponse">
          <v-divider style="margin:15px;" />
          <p>{{ $t("wallets.ethSendDescription") }}</p>
          <h4>{{ $t("wallets.walletPleaseSend1") }}</h4>
          <h3>0.0001 ETH</h3>
          <p>{{ $t("wallets.walletPleaseSend2") }}</p>
          <qrcode
            :value="userStakingWallet.verification_wallet"
            :options="{ width: 150 }"
          />
          <v-text-field
            v-model="userStakingWallet.verification_wallet"
            name="ver-wallet"
            class="centered-input"
            readonly
            @focus="$event.target.select()"
          >
            <template v-slot:append>
              <v-icon
                v-clipboard:copy="userStakingWallet.verification_wallet"
                style="cursor:pointer;"
              >
                mdi-content-copy
              </v-icon>
            </template>
          </v-text-field>
          <v-tooltip
            top
            :disabled="metamaskInstalled"
          >
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <v-btn
                  :disabled="!metamaskInstalled"
                  class="primary"
                  @click="sendViaMetamask()"
                >
                  {{ $t("wallets.metamaskButton") }}
                </v-btn>
              </div>
            </template>
            <span>{{ $t("wallets.metamaskNotInstalled") }}</span>
          </v-tooltip>
        </div>
        <div
          v-if="waitingMetamaskResponse"
          style="margin:20px 0 20px;"
        >
          {{ $t("wallets.pleaseWait") }}
          <v-progress-linear
            color="deep-purple accent-4"
            indeterminate
            rounded
            height="3"
          />
        </div>
      </center>
    </v-flex>
    <v-flex
      v-if="!$apollo.loading && step == 3"
      pt-10
      pb-10
    >
      <center>
        <v-icon class="check-mark">
          mdi-checkbox-marked-circle-outline
        </v-icon>
        <h3>{{ $t("wallets.thankYou") }}</h3>
        {{ $t("wallets.metaMaskTransactionSent") }}
      </center>
    </v-flex>
    <v-flex
      v-if="step == 4"
      pt-10
      pb-10
    >
      <center>
        <v-icon class="check-mark">
          mdi-checkbox-marked-circle-outline
        </v-icon>
        <h3>{{ $t("wallets.walletCongrats") }}</h3>
        {{ $t("wallets.walletVerified") }}
        <v-divider style="margin:15px 0 15px;" />
        <v-btn
          class="primary"
          @click="$router.push('/invoices')"
        >
          {{ $t("wallets.payInvoicesButton") }}
        </v-btn>
      </center>
    </v-flex>
  </v-layout>
</template>

<script>
const WAValidator = require("wallet-address-validator");

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { mapMutations, mapGetters } from "vuex";

import Metamask from "@/utils/metamask";
import VueQrcode from "@chenfengyuan/vue-qrcode";
import VueCountdown from "@chenfengyuan/vue-countdown";

import VERIFY_STAKING_WALLET_MUTATION from "@/graphql/mutations/VerifyStakingWallet.gql";

const validate_wallet = value => {
  if (value == "" || value == null) return true;
  return WAValidator.validate(value, "ETH");
};
import store from "@/store";

export default {
  name: "VerifyWallet",
  components: {
    qrcode: VueQrcode,
    countdown: VueCountdown,
  },
  mixins: [validationMixin],
  data() {
    return {
      step: true,
      startOverButton: false,
      verificationWallet: null,
      metamask: null,
      metamaskInstalled: false,
      metamask_logo: require("@/images/metamask.png"),
      stakingWallet: null,
      waitingMetamaskResponse: false,
      loading: false
    };
  },
  computed: {
    ...mapGetters("invoice",["getPending"]),
    countDownTime() {
      let utc = this.$moment().add(-this.$moment().utcOffset(), 'm').utc();
      let started = this.$moment(this.userStakingWallet.verification_started_at)
      let time =
        60 * 30 * 1000  -
        Math.abs(utc.diff(started, 'seconds'));
      return time > 0 ? time : 0;
    },
    walletError() {
      const errors = [];
      if (!this.$v.stakingWallet.$dirty) return errors;
      !this.$v.stakingWallet.required &&
        errors.push(this.$t("wallets.reqWallet"));
      !this.$v.stakingWallet.validate_wallet &&
        errors.push(this.$t("wallets.ethWalletNotValid"));
      return errors;
    }
  },
  mounted() {
    this.metamask = new Metamask();
    this.metamaskInstalled = this.metamask.isInstalled();
  },
  beforeDestroy() {
    this.$apollo.queries.userStakingWallet.stopPolling();
  },
  methods: {
    ...mapMutations("user", ["setUserStakingWallet"]),
    verifyWallet() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.loading = true;
        this.$apollo
          .mutate({
            mutation: VERIFY_STAKING_WALLET_MUTATION,
            variables: {
              wallet_address: this.stakingWallet
            }
          })
          .then(data => {
            this.userStakingWallet = data.data.verifyStakingWallet
            this.step = 2;
            this.loading = false;
          })
          .catch(error => {
            this.errorHandler(error);
            this.loading = false;
          });
      }
    },
    startOver() {
      this.step = 1
      this.loading = false;
    },
    handleCountDownEnd() {
      this.startOverButton = true;
      this.loading = false;
    },
    transform(props) {
      Object.entries(props).forEach(([key, value]) => {
        const digits = value < 10 ? `0${value}` : value;
        props[key] = `${digits}`;
      });
      return props;
    },
    async sendViaMetamask() {
      if (this.metamask.getProvider() != "ethereum") {
        store.commit("app/setNotifier", this.$t("proile.metaMaskVersion"));
        return;
      }

      try {
        let enabled = await ethereum.enable();
      } catch (error) {
        store.commit("app/setNotifier", this.$t("wallets.metaMaskAccept"));
      }
      let account = await this.metamask.getAccount();
      let balance = (await this.metamask.getBalance(account)) / 10 ** 18;
      let gasPrice = await this.metamask.getGasPrice();
      let amount = this.userStakingWallet.eth_amount || 0.0001;

      if (balance < amount) {
        store.commit(
          "app/setNotifier",
          this.$t("wallets.metaMaskNotEnoughAmount")
        );
        return;
      }

      let data = {
        from: account,
        to: this.userStakingWallet.verification_wallet,
        value: amount * 10 ** 18
      };

      let receipt = null;

      try {
        this.waitingMetamaskResponse = true;
        let receipt = await this.metamask.sendTransaction(data);
        if (receipt != null) {
          this.step = 3
          this.waitingMetamaskResponse = false;
        }
      } catch (error) {
        this.waitingMetamaskResponse = false;
        store.commit(
          "app/setNotifier",
          this.$t("wallets.metaMaskTransactionDeclined")
        );
      }
    }
  },
  validations() {
    return {
      stakingWallet: {
        required,
        validate_wallet
      }
    };
  },
  apollo: {
    userStakingWallet: {
      query: require("@/graphql/queries/UserStakingWallet.gql"),
      pollInterval: 30 * 1000,
      result(data) {
        if (data.loading == false) {
          if (data.data.userStakingWallet != null) {
            if (
              data.data.userStakingWallet.status == "verifying" &&
              this.step != 3 &&
              this.step != 2
            ) {
              this.step = 2;
              return;
            }
            if (data.data.userStakingWallet.status == "verified") {
              this.$apollo.queries.userStakingWallet.stopPolling();
              this.setUserStakingWallet(data.data.userStakingWallet);
              if (this.getPending == null) {
                this.step = 4;
                return
              }
              this.$emit("onVerified")
            }
          } else {
            if (this.$route.params.id == 1) return;
            this.step = 1;
          }
        }
      }
    }
  }
};
</script>

<style lang="scss">
.wallet-card {
  .v-input {
    input {
      font-size: 15px !important;
    }
  }

  padding: 0;

  h3 {
    margin: 5px;
  }

  h4 {
    margin: 15px 0 0;
    font-weight: 600 !important;
  }

  center {
    margin-top: 10px;
  }

  .v-card__title {
    margin-bottom: 30px !important;
  }

  p {
    margin: 0;
  }

  .centered-input {
    input {
      text-align: center !important;
    }
  }

  .v-image {
    margin: 15px 0 10px;
  }

  .check-mark {
    color: #75b211;
    font-size: 54px;
  }
}
</style>
